import { z } from 'zod';

const envSchema = z.object({
  // API
  VITE_API_BASE_URL: z.string().url().default('http://localhost:8000'),

  // Monitoring
  VITE_SENTRY_DSN: z.string().optional(),

  // Feature Flags
  VITE_STATSIG_SDK_KEY: z.string().default('client-dev-key'),

  // Session
  VITE_SESSION_KEY: z.string().default('session'),

  // Environment
  MODE: z.enum(['development', 'production', 'test']).default('development'),
});

export const env = envSchema.parse(import.meta.env);

// Type-safe environment
export type Env = z.infer<typeof envSchema>;
